/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { UploadTypeEnum } from "./UploadTypeEnum";
import {
  UploadTypeEnumFromJSON,
  UploadTypeEnumFromJSONTyped,
  UploadTypeEnumToJSON,
  UploadTypeEnumToJSONTyped,
} from "./UploadTypeEnum";
import type { FileStateEnum } from "./FileStateEnum";
import {
  FileStateEnumFromJSON,
  FileStateEnumFromJSONTyped,
  FileStateEnumToJSON,
  FileStateEnumToJSONTyped,
} from "./FileStateEnum";

/**
 *
 * @export
 * @interface FileReadOnly
 */
export interface FileReadOnly {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly filename?: string;
  /**
   *
   */
  readonly state?: FileStateEnum;
  /**
   *
   */
  stateDescription?: string | null;
  /**
   *
   */
  readonly type?: UploadTypeEnum;
  /**
   * Filesize in bytes
   */
  readonly size?: number | null;
  /**
   * Optional eTag (md5sum)
   */
  etag?: string | null;
  /**
   *
   */
  readonly expiryDate?: Date;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly meta?: any | null;
}

/**
 * Check if a given object implements the FileReadOnly interface.
 */
export function instanceOfFileReadOnly(value: object): value is FileReadOnly {
  return true;
}

export function FileReadOnlyFromJSON(json: any): FileReadOnly {
  return FileReadOnlyFromJSONTyped(json, false);
}

export function FileReadOnlyFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileReadOnly {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    filename: json["filename"] == null ? undefined : json["filename"],
    state: json["state"] == null ? undefined : FileStateEnumFromJSON(json["state"]),
    stateDescription:
      json["state_description"] === undefined
        ? undefined
        : json["state_description"] === null
        ? null
        : json["state_description"],
    type: json["type"] == null ? undefined : UploadTypeEnumFromJSON(json["type"]),
    size: json["size"] === undefined ? undefined : json["size"] === null ? null : json["size"],
    etag: json["etag"] === undefined ? undefined : json["etag"] === null ? null : json["etag"],
    expiryDate: json["expiry_date"] == null ? undefined : parseDate(json["expiry_date"]),
    id: json["id"] == null ? undefined : json["id"],
    meta: json["meta"] === undefined ? undefined : json["meta"] === null ? null : json["meta"],
  };
}

export function FileReadOnlyToJSON(json: any): FileReadOnly {
  return FileReadOnlyToJSONTyped(json, false);
}

export function FileReadOnlyToJSONTyped(
  value?: Omit<
    FileReadOnly,
    "url" | "filename" | "state" | "type" | "size" | "expiryDate" | "id" | "meta"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    state_description: value["stateDescription"],
    etag: value["etag"],
  };
}
